var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowSmWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 0.304687L0.333008 10.697L12.333 10.697L6.33301 0.304687Z",
    fill: "#FFC000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowSmWarn);
export default __webpack_public_path__ + "static/media/up-arrow-sm-warn.5315e9369b75568103af99cab9652df9.svg";
export { ForwardRef as ReactComponent };